import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useEditEmployeePageHeader = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const employeeId = useMemo(() => {
    const id = searchParams.get('id');
    if (!id) {
      return 0;
    }
    const parsed = Number(id);
    if (Number.isNaN(parsed)) {
      return 0;
    }
    return parsed;
  }, [searchParams]);

  const isPortfolioTab = useMemo(
    () => searchParams.get('key') === '6',
    [searchParams]
  );

  const openAddImageModal = () => {
    const nextParams = new URLSearchParams(searchParams);
    nextParams.set('portfolioAction', 'add');
    setSearchParams(nextParams);
  };

  return {
    employeeId,
    isPortfolioTab,
    openAddImageModal,
  };
};
